import React, {Dispatch, SetStateAction} from 'react';
import {Form, Formik} from 'formik';
import LightGreenButton from '../Buttons/LightGreenButton';
import GreenButton from '../Buttons/GreenButton';
import FilterBySixMonths from './Components/FilterBySixMonths';
import FilterDay from './Components/FilterDay';
import {useTranslation} from 'react-i18next';
import {RequestPremiaType} from '../../types/TypesUserAccounts';
import {monthNow} from '../../assets/utils/dateUtils';

interface Props {
	active: boolean;
	setActive: (b: boolean) => void;
	type: 'OPTIMA' | 'PersonalVolume' | 'Cashback';
	setFilters: Dispatch<SetStateAction<RequestPremiaType>>;
	onFilterApplied?: () => void;
}

const MyAccountsFilterNew: React.FC<Props> = ({
	active,
	setActive,
	type,
	setFilters,
	onFilterApplied,
}) => {
	const {t} = useTranslation();
	const initialMonth = monthNow();
	const initialValues = {month: initialMonth, selected_date: ''};

	const handleSubmit = (values: any) => {
		const filtersToApply: RequestPremiaType = {month: values.month};
		if (values.selected_date) {
			filtersToApply.selected_date = values.selected_date;
		}
		setFilters(filtersToApply);
		setActive(false);
		onFilterApplied?.();
	};

	const handleReset = (
		resetForm: () => void,
		setFieldValue: any,
	) => {
		const currentMonth = monthNow();
		resetForm();
		// Устанавливаем значения после сброса формы
		setFieldValue('month', currentMonth);
		setFieldValue('selected_date', '');
		// Применяем фильтры с текущим месяцем
		setFilters({month: currentMonth});
		onFilterApplied?.();
	};

	return (
		<div
			className={`filter-team__filter-item item-filter ${!active ? '' : 'active'}`}
		>
			<div className="item-filter__wrapper">
				<Formik
					initialValues={initialValues}
					onSubmit={handleSubmit}
					enableReinitialize
				>
					{({handleSubmit, setFieldValue, resetForm, values}) => {
						return (
							<Form
								onSubmit={handleSubmit}
								className="item-filter__form form-filter"
							>
								<FilterBySixMonths
									setFieldValue={setFieldValue}
									initialMonth={values.month || initialMonth}
								/>
								{type !== 'PersonalVolume' && (
									<div className="form-filter__item form-filter__item-select2">
										<FilterDay
											setFieldValue={setFieldValue}
											inputName={'selected_date'}
											label={t('Вибір дати')}
											defaultDate={values.selected_date}
										/>
									</div>
								)}
								<div className="item-filter__buttons">
									<LightGreenButton text={t('Застосувати')} type={'submit'} />
									<GreenButton
										onClick={() => handleReset(resetForm, setFieldValue)}
										text={t('Очистити')}
										type={'button'}
									/>
								</div>
							</Form>
						);
					}}
				</Formik>
			</div>
		</div>
	);
};

export default MyAccountsFilterNew;
